import React from 'react';
import { Button, Form, Input, Row, Col, Select, Cascader } from 'antd';
const FormItem = Form.Item;
const Option = Select.Option;
import { observer, inject } from 'mobx-react';
import { sortBy, isNil } from 'lodash';
import cityOptions from '../../const/citys';
import styles from './DeviceSearchForm.less';
import { formItemLayout } from '../../const/FormConst';

@inject('addGroupStore')
@observer
class SearchComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appList: [],
      deviceTypeList: [],
      currentVersions: [],
      more: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeMore = this.changeMore.bind(this);
  }
  componentDidMount() {
    Promise.all([
      this.props.addGroupStore.loadAppList(),
      this.props.addGroupStore.loadDeviceType(),
      this.props.addGroupStore.getCurrentOta()
    ]).then(([appList, deviceTypeList, currentVersions]) => {
      this.setState({ appList, deviceTypeList, currentVersions });
    });
  }
  componentWillUnmount() {
    this.props.form.resetFields();
  }
  changeMore() {
    this.setState({
      more: !this.state.more
    });
  }
  handleSubmit() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        console.log(value.firmware);
        let data = {
          device_id: value.device_id,
          modelNum: value.modelNum,
          firmware: value.firmware,
          appId: value.appId,
          appVersion: value.appVersion
        };
        if (
          value.distribution &&
          value.distribution.length &&
          value.distribution[0] !== 'all'
        ) {
          data.province = value.distribution[0];
          data.city = value.distribution[1] || undefined;
        }
        console.log(data);
        this.props.addGroupStore.searchDevice(data);
      }
    });
  }
  render() {
    const { appList, deviceTypeList, currentVersions } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const formatAppVersion = () => {
      const whichApp = getFieldValue('appId');
      if (whichApp) {
        const [app] =
          appList.filter(item => item['app_id'] === Number(whichApp)) || {};
        let arr = app['file_list'].map(item => item['app_version']);
        return arr;
      }
      return [];
    };
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col span={6}>
            <FormItem {...formItemLayout} label="设备编号">
              {getFieldDecorator('device_id', {
                rules: [{ pattern: /^[0-9A-F,]*$/, message: '请输入0~9,A~F' }]
              })(<Input placeholder="请输入设备编号" />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem {...formItemLayout} label="设备型号">
              {getFieldDecorator('modelNum')(
                <Select allowClear>
                  {[...deviceTypeList].map((item, index) => (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem {...formItemLayout} label="固件版本">
              {getFieldDecorator('firmware')(
                <Select allowClear>
                  {[...currentVersions].map((item, index) => (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col
            span={1}
            className={styles.moreContainer}
            onClick={this.changeMore}
          >
            {!this.state.more ? '更多' : '收起'}
          </Col>
          <Col span={2} offset={1}>
            <Button type="primary" onClick={this.handleSubmit}>
              搜索
            </Button>
          </Col>
        </Row>
        {this.state.more && (
          <Row>
            <Col span={6}>
              <FormItem {...formItemLayout} label="App名称">
                {getFieldDecorator('appId')(
                  <Select allowClear>
                    {[...appList].map(item => (
                      <Option
                        key={item['app_name']}
                        value={item['app_id'] + ''}
                      >
                        {item['app_name']}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem {...formItemLayout} label="App版本">
                {getFieldDecorator('appVersion')(
                  <Select allowClear>
                    {formatAppVersion([...appList]).map((item, index) => (
                      <Option key={index + item} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem {...formItemLayout} label="统计区域">
                {getFieldDecorator('distribution')(
                  <Cascader
                    options={cityOptions}
                    placeholder="请选择统计区域"
                    changeOnSelect
                  />
                )}
              </FormItem>
            </Col>
          </Row>
        )}
      </Form>
    );
  }
}
const DeviceGroupForm = Form.create()(SearchComponent);
export default DeviceGroupForm;



// WEBPACK FOOTER //
// ./src/components/DeviceGroup/DeviceSearchForm.js